export const onlyUnique = (value, index, self) => self.findIndex((v) => v.type === value.type) === index
